export default __webpack_public_path__ + "static/media/button.26322370.svg";